import { __EIGHT_DIGITS__ } from '@types'

export const getTotalCost = (initMintPrice: string, estimatedGasFees: string): string => {
    return (Number.parseFloat(initMintPrice) + Number.parseFloat(estimatedGasFees)).toFixed(__EIGHT_DIGITS__)
}
